export default {
  meta: {
    title: '审批流编辑',
    url: '/system/approvalflow', // 埋点用，记录所属模块
    parentPath: ['/system'],
    breadcrumbs: {
      path: ['/system/approvalflowlist'],
      name: ['审批流程配置'],
      // noShow: true,
    },
  },
};
